<template>
  <div>

<!-- probably want to add ability for FC to mark these issues as complete, and have them render as such for the office -->
<!-- or... create the new task system;) - MJ -->

    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :loading='isLoading'
      :showHelp='showHelp'
      :showAdd='!disableAdd'
      :helpText="helpText"
      @add='addNew'
    >
      <v-card flat v-if='issues.length === 0'>
        <v-card-text>
          {{ isLoading ? "Loading..." : "None found." }}
        </v-card-text>
      </v-card>
      <template v-for='(issue, index) in issues'>
        <v-divider v-if='index > 0' :key='issue.id'></v-divider>
        <v-card flat :key="index + '-' + issue.id" @click='edit(issue)'>
          <v-card-subtitle class='pb-2 d-flex align-baseline'>
            <wc-avatar :profile='issue.created_by ? issue.created_by_obj : null'></wc-avatar>
            <span class='mx-2 heading-6'>{{ issue.date_created | shortDate }}</span>
            <v-spacer></v-spacer>
            <small>
              <span class='caption font-weight-bold mr-1'>TTC:</span>
              <span v-if='issue.time_to_complete'>{{ issue.time_to_complete }} mins</span>
              <span v-else class='font-italic grey--text'>not set</span>
            </small>
          </v-card-subtitle>
          <v-card-text>
            <span class='black--text'>{{ issue.issue }}</span>
          </v-card-text>
        </v-card>
      </template>

    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      :disableButtons='!isFormValid || disableEdit'
      :fullscreen='$vuetify.breakpoint.xs'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-form v-model='isFormValid'>
        <v-textarea
          outlined
          label='Outstanding Service Issue'
          auto-grow
          v-model='issueCopy.issue'
          :rules='[rules.required]'
        ></v-textarea>
        <span class='caption grey--text text--darken-2'>This issue will be attached to future Start Up and Service work orders.</span>
        <br><br>
        <v-text-field
          prepend-icon='mdi-clock'
          label='Estimated time to complete'
          hint='In minutes'
          v-model='issueCopy.time_to_complete'
          :rules='[rules.int]'
        ></v-text-field>
      </v-form>
      <template v-slot:dialog-actions v-if='issueCopy.id'>
        <v-btn depressed small color='error' :disabled='disableEdit' @click='showConfirm = true'>Delete</v-btn>
      </template>
    </wc-dialog>

    <wc-confirm :showDialog='showConfirm' @confirm='deleteIssue'>
      Are you sure you want to delete this outstanding service issue? This cannot be undone!
    </wc-confirm>
  </div>
</template>

<script>
import _ from 'lodash'
import miscServices from '@/services/misc'
import formRules from '@/mixins/formRules'
import projectsAPI from '../api/projects'

export default {
  name: 'outstanding-service',
  mixins: [formRules],
  props: {
    project: {
      required: true
    },
    disableAdd: {
      required: false,
      type: Boolean,
      default: false
    },
    allowEdits: {
      required: false,
      type: Boolean,
      default: false
    },
    showHelp: {
      required: false,
      type: Boolean,
      default: false
    },
    helpText: {
      required: false,
      type: String,
      default: "These are issues that field crews have noticed while on site, and should be brought to the owner's attention."
    },
    fieldcrew: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    showConfirm: false,
    icon: 'mdi-text-subject',
    iconColor: 'warning',
    issues: [],
    issueCopy: {
      'project': null,
      'issue': '',
      'time_to_complete': 0
    },
    showDialog: false
  }),
  mounted () {
    this.getData()
  },
  watch: {
    'project.id' (newId, oldId) {
      if (newId !== oldId) {
        this.getData()
      }
    }
  },
  computed: {
    title () {
      return this.$vuetify.breakpoint.xs ? "O/S Service" : "O/S Service Issues"
    },
    disableEdit () {
      if (this.allowEdits || ( this.$store.state.auth.profile.id == this.issueCopy.created_by) ) {
        return false
      }
      return true
    }
  },
  methods: {
    issueCopyReset () {
      this.issueCopy.id = null
      this.issueCopy.project = this.project.id
      this.issueCopy.issue = ''
      this.issueCopy.time_to_complete = null
      this.issueCopy.created_by = this.$store.state.auth.profile.id
    },
    async getData () {
      this.isLoading = true
      if (this.fieldcrew) {
        this.issues = await projectsAPI.getProjectOutstandingServiceForWO(this.project.id)
        // the differnce here is a filter of "?is_complete=false"
      } else {
        this.issues = await projectsAPI.getProjectOutstandingService(this.project.id)
      }
      this.isLoading = false
    },
    async deleteIssue () {
      this.issues = miscServices.removeObject(this.issues, this.issueCopy)
      projectsAPI.removeProjectOutstandingService(this.issueCopy)
      this.showDialog = false
      this.showConfirm = false
    },
    edit (item) {
      this.issueCopy = _.cloneDeep(item)
      this.showDialog = true
    },
    addNew () {
      this.issueCopyReset()
      this.showDialog = true
    },
    async saveChanges () {
      this.isLoading = true
      if (this.issueCopy.id) {
        let tmp = await projectsAPI.updateProjectOutstandingService(this.issueCopy)
        this.issues = miscServices.replaceObject(this.issues, tmp)
      } else {
        let tmp = await projectsAPI.addProjectOutstandingService(this.issueCopy)
        this.issues.push(tmp)
      }
      this.showDialog = false
      this.isLoading = false
    }
  }
}
</script>
